<template>
    <div
        class="columns"
        :class="columnClasses"
    >
        <slot />
    </div>
</template>

<script>
    /**
    * Component
    */
    export default {
        name: 'column',
        props: {
            shrink: {
                type: Boolean,
                required: false,
                default: false
            },
            small: {
                type: Number,
                required: false,
                default: null
            },
            medium: {
                type: Number,
                required: false,
                default: null
            },
            large: {
                type: Number,
                required: false,
                default: null
            },
            fluid: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data () {
            return {
                sizes: ['small', 'medium', 'large']
            }
        },
        methods: {
            getSize (width) {
                return (width > 1 && width <= 12) ? width : 12
            }
        },
        computed: {
            smallSize () {
                return `small-${this.getSize(this.small)}`
            },
            mediumSize () {
                return `medium-${this.getSize(this.medium)}`
            },
            largeSize () {
                return `large-${this.getSize(this.large)}`
            },
            columnClasses () {
                switch (true) {
                    case this.fluid:
                        return null
                    case this.shrink:
                        return 'shrink'
                    default:
                        let arr = []
                        this.sizes.forEach(s => {
                            let i = `${s}Size`
                            if (this[s]) arr.push(this[i])
                        })

                        return arr
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Column.vue